/**
 * Created by alex.y on 11/27/2017.
 */

import {Directive, forwardRef, Input} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {Location} from "../../../objects/management/locationManagement/location";
import {ExtraDataService} from "../../../services/extraDataService";

@Directive({
    selector: '[validateProductName][ngControl],[validateProductName][ngFormControl],[validateProductName][ngModel]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ProductValidatorValidatorDirective), multi: true}
    ]
})
export class ProductValidatorValidatorDirective implements Validator {
    constructor() {
    }

    private onChange: () => void;

    validate(control: AbstractControl): { [key: string]: any } {
        if (!control.value)
            return null;

        let name = control.value.trim();

        let hsCodeSplitted = name.split(/\d+\.[\d+.*]+/i);

         let matches = name.match(/\d+\.[\d+.*]+/ig);

        let wordCounter = matches ? matches.length : 0;

        let splitted = hsCodeSplitted.join(" ").split(/[.|\\|/|,|;|:|||!|?|&|\s]/);

       for(let it of splitted){
           if(!String.isNullOrEmpty(it) && it.match(/^[@#$%^&*()_+\-=\[\]{}'"|<>]+$/) == null)
               wordCounter++;
       }

        if(wordCounter <= 1)
            return {validateProductName: false};

        return null;
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/validators/productNameValidator.ts